import { ReactElement, useEffect, useMemo, useRef } from "react";
import { useDependency } from "../../../contexts/DependencyContext";
import { useViewTypeUpdate, ViewType } from "../../../contexts/ViewTypeContext";
import { ComponentModelService } from "../../../services/ComponentModelService";
import Spinner from "../../../components/Shared/Spinner";
import WidgetItem from "./WidgetItem";
import styles from "./DashboardView.module.scss";

const DashboardView = (): ReactElement | null =>
{
    const service = useDependency(ComponentModelService);
    const viewTypeUpdate = useViewTypeUpdate();
    const { widgets } = service.componentModel;
    const dashboard = useRef(null as any);
    const loading = !widgets;
    const widgetIds = useMemo(() => widgets.map(x => x.id).join(), [widgets]);

    function enableScroll(index: number): void
    {
        if (index === widgets.length) dashboard.current.classList.add("scroll-container");
    }

    useEffect(() => viewTypeUpdate(ViewType.Dashboard), [viewTypeUpdate]);
    useEffect(() => dashboard.current.classList.remove("scroll-container"), [widgetIds]);

    return (
        <div ref={dashboard} className={styles.dashboard}>
            {loading && <Spinner caption="Loading widgets..." />}

            {widgets && widgets.map((x, i) =>
            {
                const configuration = JSON.parse(x.uiConfiguration);

                return (
                    <WidgetItem
                        key={x.id}
                        index={x.displayOrder || i}
                        widget={x}
                        visualClasses={configuration.visualClasses}
                        enableScroll={enableScroll}
                    />
                )
            })}
        </div>
    );
}

export default DashboardView;